import Vue from "vue";

export default Vue.extend({
  name: 'ProviderWorkSummaryReport',
  data() {
    return {
      inputParams: {}
    }
  },
});



// WEBPACK FOOTER //
// ./src/components/reports/providerworksummary/ProviderWorkSummaryReport.ts